module.exports = __webpack_public_path__ + "static/media/dcp-horizontal-logo.c7ab5aa0.svg";